module.exports = {"id":"dp2_1l1q2","text":"Interacting Through Digital Technologies","instructions":"Which example best represents asynchronous digital communication?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l1q2-a1","text":"Email sent without instant reply","score":1.8},{"id":"dp2_1l1q2-a2","text":"Live video conference call","score":0},{"id":"dp2_1l1q2-a3","text":"In-person spoken discussion","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l1q2.json
// module id = 987
// module chunks = 41